var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingbasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1573 1.07098C23.2228 1.71031 23.5684 3.0924 22.929 4.15796L13.929 19.158C13.2897 20.2235 11.9076 20.569 10.842 19.9297C9.77649 19.2904 9.43097 17.9083 10.0703 16.8427L19.0703 1.84272C19.7096 0.777169 21.0917 0.431648 22.1573 1.07098Z",
    fill: "#00D32E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1573 19.9297C48.0917 20.569 46.7096 20.2235 46.0703 19.158L37.0703 4.15795C36.431 3.0924 36.7765 1.71031 37.842 1.07098C38.9076 0.431647 40.2897 0.777169 40.929 1.84272L49.929 16.8427C50.5684 17.9083 50.2228 19.2904 49.1573 19.9297Z",
    fill: "#00D32E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.8459 53.424C53.7064 58.9997 48.8418 63 43.2007 63H16.7993C11.1583 63 6.29361 58.9997 5.15412 53.424L0.249366 29.424C-1.27218 21.9787 4.36209 15 11.8946 15L48.1054 15C55.6379 15 61.2722 21.9787 59.7506 29.424L54.8459 53.424Z",
    fill: "#00D32E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1054 15H11.8946C5.18813 15 -0.0136118 20.532 2.67576e-05 27H60C60.0136 20.532 54.8119 15 48.1054 15Z",
    fill: "#00D32E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4817 37.3067C41.4169 38.125 41.5117 39.5465 40.6934 40.4817L32.0837 50.3213C30.2336 52.4357 27.0468 52.7188 24.853 50.9638L19.5945 46.757C18.6242 45.9807 18.4669 44.5648 19.2431 43.5945C20.0194 42.6241 21.4353 42.4668 22.4056 43.2431L27.6641 47.4498C27.9775 47.7006 28.4328 47.6601 28.6971 47.3581L37.3068 37.5184C38.1251 36.5832 39.5465 36.4884 40.4817 37.3067Z",
    fill: "#00D32E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbasket);
export default __webpack_public_path__ + "static/media/shopping basket.136e87769c572d1232482ca27d934f62.svg";
export { ForwardRef as ReactComponent };